import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSlider from './components/HeroSlider';
import ServicesSection from './components/ServicesSection';
import StaffSection from './components/StaffSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import { useSEO } from '../../utils/seo';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://okayama-doboku.com';
  
  useSEO({
    title: '岡山市・倉敷市の土木工事・水道・舗装工事なら おかやま土木工事株式会社 - 地域密着で安心施工',
    description: '岡山市・倉敷市を中心とした岡山県内の土木工事、水道工事、舗装工事のことなら おかやま土木工事株式会社にお任せください。地域密着で20年以上の実績、確かな技術と丁寧な施工で安心をお届けします。無料見積もり・相談受付中。',
    keywords: '岡山市土木工事,倉敷市土木工事,水道工事,舗装工事,岡山県',
    canonical: '/',
    ogType: 'website',
    schema: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "おかやま土木工事株式会社",
      "description": "岡山市・倉敷市を中心とした土木工事、水道工事、舗装工事",
      "url": siteUrl,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "○○町1-2-3",
        "addressLocality": "岡山市北区",
        "addressRegion": "岡山県",
        "addressCountry": "JP"
      },
      "telephone": "086-012-3456",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      "foundingDate": "2000",
      "numberOfEmployees": "5"
    }
  });

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSlider />
        <ServicesSection />
        <StaffSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
